import React, { useState } from "react";
import api from "../../api/api";
import { useSelector } from "react-redux";

const MessagingIframePage = () => {
  const userState = useSelector((store) => store.user);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [opened, setOpened] = useState(false);

  const handleOpen = async () => {
    setOpened(true);
    setLoading(true);
    setError(null);

    // Attempt to derive credentials from user state; fallback to sample if absent
    const orgId = userState?.customerId || userState?.orgId || 364;
    const userId = userState?.userId || 1010544;
    const username = userState?.username || "TankP255";

    const payload = {
      orgId: String(orgId),
      memberDUID: String(userId),
      username,
    };

    const result = await api.parishSoft.startCommunication(payload);
    if (result?.success && result?.iframeUrl) {
      setIframeUrl(result.iframeUrl);
      setLoading(false);
    } else 
    {
      setError(result?.errorMessage || "Failed to load messaging iframe.");
      setLoading(false);
    }
  };

  const pageStyle = {
    width: "100%",
    minHeight: "100vh",
    background: "#f3f4f6",
    padding: "20px",
    boxSizing: "border-box",
  };

  const shellStyle = {
    maxWidth: 1280,
    margin: "0 auto",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
    overflow: "hidden",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
    borderBottom: "1px solid #e5e7eb",
    background: "#f9fafb",
  };

  const titleStyle = { fontSize: 16, fontWeight: 600, color: "#111827" };

  const buttonStyle = {
    background: "#2563eb",
    color: "#ffffff",
    border: 0,
    borderRadius: 6,
    padding: "8px 12px",
    fontWeight: 600,
    cursor: "pointer",
  };

  const bodyStyle = { padding: 16 };

  const frameWrapStyle = {
    border: "1px solid #d1d5db",
    borderRadius: 6,
    overflow: "hidden",
    background: "#111827",
  };

  const iframeStyle = {
    width: "100%",
    height: "80vh",
    border: "0",
    display: "block",
  };

  const handleClose = () => {
    setOpened(false);
    setError(null);
    // keep iframeUrl cached; re-fetch on next open if needed
  };

  return (
    <div style={pageStyle}>
      <div style={shellStyle}>
        <div style={headerStyle}>
          <div style={titleStyle}>ParishSOFT • Communications</div>
          {!opened ? (
            <button style={buttonStyle} onClick={handleOpen}>
              Open Communication
            </button>
          ) : (
            <button
              style={{ ...buttonStyle, background: "#6b7280" }}
              onClick={handleClose}
              aria-label="Close communication panel"
            >
              Close
            </button>
          )}
        </div>
        <div style={bodyStyle}>
          {!opened && (
            <div>
              <p style={{ margin: 0, color: "#374151" }}>
                Click the button to launch HGS Communications inside ParishSOFT.
              </p>
            </div>
          )}

          {opened && (
            <>
              {loading && (
                <div style={{ padding: 12, color: "#374151" }}>
                  Opening Communication…
                </div>
              )}
              {error && (
                <div style={{ padding: 12, color: "#b91c1c" }}>
                  Error: {error}
                </div>
              )}
              {!loading && !error && (
                <div style={frameWrapStyle}>
                  <iframe
                    src={iframeUrl || "/messages-embed"}
                    title="Messages Tab"
                    style={iframeStyle}
                    allow="microphone"
                    allowFullScreen
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagingIframePage;
